import styled from "@emotion/styled";
import dynamic from "next/dynamic";
import Image from "next/image";
import Link from "next/link";
import animationData from 'public/animation/arrow.json';
import { trackEventByNameAndType } from "reusable/ChargeGTM";
import { NewText, extractProperty } from "ui";
import { sharedColors } from "ui/theme/colors";
import { getNonUmbracoURL, getUmbracoMediaUrl } from "utils/utils";
// Dynamically import Lottie to ensure it's client-only
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

const StyledServiceCard = styled.div`
display: grid;
row-gap: 20px;
padding: 20px;
gap: 20px;
width: 100%;
height: 330px;
background: rgba(21, 62, 105, 0.1);
border-radius: 12px;

${(props) => props.theme.breakpoints.up("md")} {
   width: 370px;
    height: 330px;
}
`

const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    gap: 5px;
    color: #0050C9;
    font-weight: 500;
    text-decoration: none;
    :hover{
        text-decoration: underline;
    }
`
const StyledLottieWrapper = styled.div`
    width: 24px;
`
interface StationTypeCardChargeProps {
    data: any
}
function StationTypeCardCharge({ data }: StationTypeCardChargeProps) {

    const title = extractProperty(data, "title")
    const image = extractProperty(data, "image")
    const text = extractProperty(data, "text")
    const links = extractProperty(data, "link")
    const url = getNonUmbracoURL(links[0]?.url) || ""

    return (
        <StyledServiceCard>
            <Image
                src={getUmbracoMediaUrl(image)}
                width={140}
                height={140}
                alt=""
                style={{ borderRadius: 50 }}
            ></Image>
            <div>
                <NewText
                    desktopFontSize={18}
                    desktopFontWeight={500}
                    desktopLineHeight={"20px"}
                    mobileFontSize={16}
                    mobileLineHeight={"18px"}
                    mobileFontWeight={500}
                    component={"h3"}
                    style={{paddingBottom: 5}}
                >
                    {title}
                </NewText>

                <NewText
                    desktopFontSize={18}
                    desktopFontWeight={400}
                    desktopLineHeight={"20px"}
                    mobileFontSize={16}
                    mobileLineHeight={"18px"}
                    mobileFontWeight={400}
                    component={"p"}
                >
                    {text}
                </NewText>
            </div>

            <StyledLink href={url} color={sharedColors.blue} aria-label={`למידע נוסף אודות ${title}`} aria-hidden onClick={() => {
                const type = url.includes("public-charging-stations") ? 'עמדות טעינה ציבורית' : 'ציי רכב וחברות'
                trackEventByNameAndType('charging_station_read_more', type)
            }
                }>
                למידע נוסף
                <StyledLottieWrapper >
                    <Lottie animationData={animationData} loop={true} color={sharedColors.blue} />
                </StyledLottieWrapper>
            </StyledLink>
        </StyledServiceCard>);
}

export default StationTypeCardCharge;
